import { TableCell } from '@mui/material';
import styled from 'styled-components';

export const StyledTableCell = styled(TableCell)({
  display: 'flex',
  flexWrap: 'nowrap',
  gap: '10px'
});
